/**
 *
 * Asynchronously loads the component for GuideLineLr
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GuideLineLR = lazyLoad(
  () => import('./index'),
  module => module.GuideLineLR,
);
